import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import {
  ICreateService,
  IGetAllServiceFilters,
  IService,
  IUpdateService,
} from '../../../../pages/management/services/service-lists/interface/services.interface';
import { IPagination } from '../../api/interface/pagination.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  constructor(private readonly apiService: ApiService) {}

  create(data: ICreateService) {
    return this.apiService.post<IService>('services/create', data);
  }
  update(data: IUpdateService) {
    return this.apiService.patch<IService>('services/update', data);
  }
  delete(id: number) {
    return this.apiService.delete<{ success: boolean }>(
      `services/delete/${id}`
    );
  }
  getAll(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>('services/get-all-list', {
      event,
      filter,
    });
  }

  getServicesWithPrice(
    filter: any,
    priceTypeId: number | null,
    date?:Date|null
  ): Observable<IServicePrice> {
    return this.apiService.post<IServicePrice>(
      'services/get-services-with-price',
      { filter, memberPriceType: priceTypeId,date }
    );
  }

  processExcel(data: { excelDatas: ICreateService[] }) {
    return this.apiService.post<any>('services/process-excel', {
      excelDatas: data.excelDatas,
    });
  }

  saveExcelDatas(data: { selectedDatas: ICreateService[] }) {
    return this.apiService.post<any>('services/create-excel-datas', {
      excelDatas: data.selectedDatas,
    });
  }

  getServices(data: { filter?: IGetAllServiceFilters }) {
    return this.apiService.post<IService[]>('services/get-services', {
      filter: data?.filter,
    });
  }

  getKdvSummary() {
    return this.apiService.get<any[]>('services/get-kdv-summary');
  }

  updateKdvRates(kdvRates: { kdvRateId: number|null; newKdvRateId: number|null }[]):Observable<{success:boolean}> {
    return this.apiService.put<{success:boolean}>('services/service-update-kdv', {
      kdvRates,
    });
  }
}

export interface IServicePrice {
  total: number;
  items: IServicePriceItems[];
}

export interface IServicePriceItems {
  serviceCode: string;
  serviceName: string;
  serviceId: number;
  gatePrice: {
    price: number | null;
    originalPrice:number | null;
    icon:string | null;
    currency: string | null;
    priceId: number | null;
    isFlexiblePrice: boolean | null;
    givenForFree: boolean | null;
  } | null;
  memberPrice: {
    price: number | null;
    originalPrice:number | null;
    currency: string | null;
    icon:string | null;
    priceId: number | null;
    isFlexiblePrice: boolean | null;
    givenForFree: boolean | null;
  } | null;
  quantity: number | null | undefined;
  total: number | null | undefined;
  unitPrice:number | null | undefined;
  lastPrice:number | null | undefined;
  priceType:'gatePrice'|'memberPrice' | null
 }

